import { render, staticRenderFns } from "./PendingNotifications.vue?vue&type=template&id=1bf50dbc&"
import script from "./PendingNotifications.vue?vue&type=script&lang=js&"
export * from "./PendingNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports